import React from "react";
import { Calendar, Badge, Tooltip, Empty, Space, Typography } from "antd";
import dayjs from "dayjs";
import { useMonitor } from "../context/MonitorContext";
import useTimezoneConverter from "../../../../hooks/useTimezoneConverter";
import { VIEW_TYPE } from "../constants/viewConstants";
import EnhancedFlightTimes from "./EnhancedFlightTimes";
import AircraftTag from "../../../../components/AircraftTag";

const { Text } = Typography;

const FlightCalendarView = ({ airportsMap = {} }) => {
    const { flights, loading, toggleModal, activeView } = useMonitor();
    const { fromUTC } = useTimezoneConverter();

    if (activeView !== VIEW_TYPE.CALENDAR) {
        return null; // 如果当前视图不是日历，则不渲染
    }

    const getListData = (value) => {
        const dateStr = value.format("YYYY-MM-DD");
        // 这里假设 flights 数组中的 flight_date 是 UTC 格式 "YYYY-MM-DDTHH:mm:ssZ"
        // 我们需要将 flight_date 转换为当前选定的时区再进行比较
        const listData = flights
            .filter((item) => {
                const flightLocalDate = fromUTC(item.flight_date);
                return flightLocalDate && flightLocalDate.format("YYYY-MM-DD") === dateStr;
            })
            .map((item) => ({
                type: "success", // 可以根据航班状态设置不同的颜色
                content: (
                    <>
                        <AircraftTag registration={item.aircraft_reg || "未分配"} style={{ marginRight: 4 }} />
                        {item.flight_number}
                    </>
                ),
                flight: item, // 保留完整航班信息
            }));
        return listData || [];
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <ul className="events" style={{ listStyle: "none", margin: 0, padding: 0 }}>
                {listData.map((item, index) => (
                    <li key={index} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        <EnhancedFlightTimes flight={item.flight} airportsMap={airportsMap} allFlights={flights} triggerComponent={<Badge status={item.type} text={item.content} style={{ fontSize: "10px" }} />} />
                    </li>
                ))}
            </ul>
        );
    };

    const cellRender = (current, info) => {
        if (info.type === "date") return dateCellRender(current);
        // 如果需要月视图渲染，可以在这里添加 monthCellRender 的逻辑
        return info.originNode;
    };

    if (loading) {
        return <div>加载中...</div>; // 或者使用 Skeleton 组件
    }

    if (!loading && flights.length === 0) {
        return <Empty description="当前日期范围无航班数据" />;
    }

    return (
        <>
            <div style={{ marginBottom: 16 }}>
                <Space>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                        日历视图默认显示300条航班数据
                    </Text>
                </Space>
            </div>
            <Calendar cellRender={cellRender} />
        </>
    );
};

export default FlightCalendarView;
